import { Component, Input } from '@angular/core';

type BadgeSeverity= 
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html'
})
export class BadgeComponent {
  @Input() value: string = '';
  @Input() severity: BadgeSeverity = 'info';
}
